import * as iwink_starterkit from '@iwink_starterkit/app';

// The starterkit only starts observing on DOMContentLoaded, which other scripts
// can postpone. Reveal the animated blocks as soon as this bundle runs, and
// pick up any markup that was not parsed yet as soon as parsing is done.
(function() {
  const selector = '.block-toptasks, .component-block, .site-footer-top';

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-viewport');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -10% 0px'
  });

  function observeAnimatedBlocks() {
    document.querySelectorAll(`:is(${selector}):not(.is-in-viewport)`)
      .forEach(element => observer.observe(element));
  }

  observeAnimatedBlocks();
  document.addEventListener('readystatechange', observeAnimatedBlocks, {once: true});
})();

// Remove the subscription button from any event detail page if there is no
// subscription form on that page.
(function(Drupal, once) {
  Drupal.behaviors.subscriptionLink = {
    attach(context) {
      once('subscription_link', '[data-subscription-link="anchor"]', context)
        .forEach(link => {
          const subscriptionForm = document.querySelector('#inschrijven');
          if (!subscriptionForm) {
            // If the link is in an <li>, remove that <li>,
            // else just remove the link.
            const containerLi = link.closest('li');
            (containerLi || link).remove();
          }
        });
    }
  }
})(Drupal, once);

// Place the messages in the webform block, if there is a webform block.
(function(Drupal, once) {
  Drupal.behaviors.webformMessages = {
    attach(context) {
      if (
        window.location.pathname.startsWith('/admin')
        || document.referrer.match(/\/node\/\d+\/\w+\b/)
      ) {
        return;
      }

      const drupalMessages = document.querySelector('[data-drupal-messages]');
      if (!drupalMessages) {
        return;
      }

      // If there's an error with the submission, hide the success message.
      if (drupalMessages.querySelector('.alert-warning, .alert-danger')) {
        drupalMessages.querySelectorAll('.alert-success').forEach(
          success_message => success_message.remove()
        );
      }
    }
  }
})(Drupal, once);

// On the search results page the header button focuses the main-content search
// input instead of opening a dropdown.
(function(Drupal, once) {
  Drupal.behaviors.focusSearchInput = {
    attach(context) {
      once('focus-search-input', '[data-focus-search-input]', context)
        .forEach(trigger => {
          trigger.addEventListener('click', () => {
            const input = document.querySelector('.search-form input[type="search"]');
            if (input) {
              setTimeout(() => input.focus(), 0);
            }
          });
        });
    }
  }
})(Drupal, once);
